import React, { useContext } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { ThemeContext } from 'styled-components';
import { formatValue } from '../../../../utils';
import { EmptyState } from '../../../../components';
import * as s from './styled-variables';

const Variables = ({ variables, removeVariable, values }) => {
  const { colors } = useContext(ThemeContext);

  return (
    <Scrollbars
      style={{ width: '100%', height: '100%' }}
      renderThumbHorizontal={() => <s.HiddenThumb />}
    >
      <s.Container>
        {variables.length > 0 ? (
          variables.map((variable) => (
            <s.Card key={variable.id}>
              <s.Column>
                <s.Label title>{variable.name}</s.Label>
                <s.Label
                  value
                  color={
                    variable.name === 'Valor economizado'
                      ? colors.green
                      : undefined
                  }
                >
                  {variable.name === 'Valor economizado'
                    ? values[variable.ihmname].toLocaleString()
                    : formatValue(values[variable.ihmname])}
                  {variable.range[0].unit}
                </s.Label>
              </s.Column>
              <s.Close onClick={() => removeVariable(variable.id)} />
            </s.Card>
          ))
        ) : (
          <EmptyState
            title="Nenhuma variável selecionada"
            description="Selecione variáveis da lista ao lado para visualizá-las aqui."
          />
        )}
      </s.Container>
    </Scrollbars>
  );
};

export default Variables;
